
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import bus from 'vue-bus'
import Mark from 'mark.js'
// import OcrWeb from 'ocr-vue2'

import App from './App'
import router from './router'
import Request from './components/common/request/request'
import VueCropper from 'vue-cropper'
import "babel-polyfill"
Vue.config.productionTip = false
Vue.prototype.$ocrhttp = Request
Vue.prototype.Mark = Mark
Vue.use(ElementUI)
Vue.use(bus)
Vue.use(VueCropper)
// Vue.use(OcrWeb)


new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js